"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatValidity = void 0;
const formatValidity = (catalogueId, catalogues, formatValidityDate) => {
  const catalogue = catalogues.find(e => e.catalogueId.toString() === catalogueId);
  if (!catalogue?.valid || !(catalogue.valid.from instanceof Date) || !(catalogue.valid.to instanceof Date)) {
    return null;
  }
  const from = formatValidityDate(catalogue.valid.from);
  const to = formatValidityDate(catalogue.valid.to);
  return `${from} - ${to}`;
};
exports.formatValidity = formatValidity;
